import type { AnyAction } from '@reduxjs/toolkit';
import { FetchApplicationsRoutine } from '../routines';
import type { IApplicationsListState } from '../interfaces';

export const initialState: IApplicationsListState = {
  isFetching: false,
  data: [],
  error: null,
};

export const applicationsListReducer = (
  state: IApplicationsListState = initialState,
  action: AnyAction,
): IApplicationsListState => {
  switch (action.type) {
    case FetchApplicationsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null,
      };
    case FetchApplicationsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchApplicationsRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
